import { CommonModule } from '@angular/common';
import { Component, inject, OnInit, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { MatBottomSheet, MatBottomSheetModule } from '@angular/material/bottom-sheet';
import { MatButtonModule } from '@angular/material/button';
import { DirectivesModule } from "app/shared/directives/directives.module";
import { MatIconModule } from '@angular/material/icon';
import { SmallNavigationService } from 'app/core/services/small-navigation-sevice.service';
import { ActionsBottomSheetComponent } from '../actions-bottom-sheet/actions-bottom-sheet.component';
import { NavigationEnd, Router } from '@angular/router';
import { ExpenseService } from 'app/core/services/dialogs/expense.service';
import { PaymentService } from 'app/core/services/dialogs/payment.service';
import { PageActionStateService } from 'app/core/store/page-action/page-action.state.service';
import { VehiculleService } from 'app/core/services/dialogs/vehicule.service';
import { ResourceService } from 'app/core/services/dialogs/resource.service';
import { filter, Subscription, merge } from 'rxjs';
import { PageActionService } from 'app/core/services/page-action.service';
import { ViewportService } from 'app/core/services/viewport.service';
import { GlobalService } from 'app/global.service';
import { BulkSchedulingStateService } from 'app/main/plus/calendar/bulk-scheduling.state.service';
import { CalendarSelectionStateService } from 'app/main/plus/calendar/calendar-selection.state.service';
import { TRANSLOCO_SCOPE, TranslocoModule, TranslocoService } from '@ngneat/transloco';

@Component({
  selector: 'page-action',
  standalone: true,
  imports: [
    MatButtonModule,
    MatIconModule,
    CommonModule,
    MatBottomSheetModule,
    DirectivesModule
    ,TranslocoModule
  ],
  templateUrl: './page-action.component.html',
  styleUrls: ['./page-action.component.scss'],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: { scope: 'calender', alias: 'calender' },
      multi: true
    },
    {
      provide: TRANSLOCO_SCOPE,
      useValue: { scope: 'popups', alias: 'popups' },
      multi: true
    }
  ],
})
export class PageActionComponent implements OnInit, OnDestroy {

  private _bottomSheet = inject(MatBottomSheet);
  public _smallNavService = inject(SmallNavigationService);
  private router = inject(Router);
  private _expenseService = inject(ExpenseService);
  private _paymentService = inject(PaymentService);
  private _vehiculeService = inject(VehiculleService);
  private _resourceService = inject(ResourceService);
  private _pageActionStateService = inject(PageActionStateService);
  private _pageActionService = inject(PageActionService);
  private _viewportService = inject(ViewportService);
  private _globalService = inject(GlobalService);
  private _bulkSchedulingStateService = inject(BulkSchedulingStateService);
  private _calendarSelectionState = inject(CalendarSelectionStateService);
  private _changeDetectorRef = inject(ChangeDetectorRef);
  private translocoService = inject(TranslocoService);

  public permissionList = [];
  private routeSubscription: Subscription;
  public isRecreated = false;
  
  ngOnInit() {
    // Initialize permissions immediately
    this.recreateComponent();
    // Set up route change listener
    this.updateRequiredPermissionsBasedOnRoute();
    this.setupScreenSizeListener();
  }

  private updateRequiredPermissionsBasedOnRoute() {
    // Force component recreation on every navigation by detecting route changes
    this.routeSubscription = this.router.events.pipe(
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Ensure we handle route changes immediately
      this.recreateComponent();
    });
  }
  
  private setupScreenSizeListener() {
    // Subscribe to viewport size changes
    this._viewportService.viewportSize$.subscribe(size => {
      this.recreateComponent();
    });
  }
  
  private recreateComponent() {
    // Reset state first
    this.isRecreated = false;
    this.permissionList = [];
    this._changeDetectorRef.detectChanges();
    
    // Defer permission updates to next cycle
    setTimeout(() => {
      // Make sure we get fresh permissions from the service
      if (this._smallNavService.mainAction()?.requiredPermissions) {
        this.permissionList = this._pageActionService.generateActionPermissions(
          this._smallNavService.mainAction()?.requiredPermissions
        );
      }
      
      // Restore visibility and force change detection
      this.isRecreated = true;
      this._changeDetectorRef.detectChanges();
    }, 0);
  }
  getMainActionText(): string {
  const action = this._smallNavService.mainAction();

  if (!action) {
    return '';
  }

  if (this.router.url.startsWith('/calendar') && action.icon === 'add') {
    return this.translocoService.translate('calender.mobile_add');
  }

    if (action.textKey) {
      const translatedText = this.translocoService.translate(action.textKey);
      if (translatedText !== action.textKey) return translatedText;
    }
    if (action.text === 'Enregistrer') {
      return this.translocoService.translate('calender.Enregistrer');
    }

  if (this.router.url.startsWith('/candidats')) {
    return this.translocoService.translate('navbar.ajouter');
  }

  return action.text;
}

  actionClicked(item: any): void {
    if (item.route) {
      this.router.navigate([item.route]);
    } else if (item.callback) {
      this[item.callback]();
    } else {
      const subType = this._globalService.getUser().sub_type;
      const childActions = (subType == 'code_only' && this._smallNavService.childActionsCodeOnlyVariation())
                            ? this._smallNavService.childActionsCodeOnlyVariation()
                            : this._smallNavService.childActions();   
      const useTopBarTitle: boolean = !!childActions.find(e=>e.displayInTopBar) && !!this._smallNavService.mainAction()?.topBarTitle
      

      const title = useTopBarTitle 
                    ? this._smallNavService.mainAction()?.topBarTitle 
                    : ( this._smallNavService.mainAction()?.text ?? null ) 
      this.openBottomSheet(childActions,title);
    }
  }

  openBottomSheet(childActions: any[], titleOnTop?: string): void {
    const showBulkButton = !this.router.url.startsWith('/finance/revenus')
      && this.router.url !== '/candidats/new';

    this._bottomSheet.open(ActionsBottomSheetComponent, {
    data: {
      type: 'actions',
      source: this.router.url.startsWith('/candidats') ? 'candidate-navigation' : null,
      titleOnTop: titleOnTop ?? null,
      showBulkButton,
      requiredPermissionsInTopBar: this._pageActionService.generateActionPermissions(this._smallNavService.mainAction()?.requiredPermissionsInTopBar) || null,
      displayTopBar: this._smallNavService.mainAction()?.displayTopBar,
      actions: childActions.map(action => ({
      icon: action.icon,
      text: action.text,
      textKey: action.textKey,
      route: action.route || null,
      params: action.params || null,
      requiredPermissions: this._pageActionService.generateActionPermissions(action.requiredPermissions) || null,
      displayInTopBar: action?.displayInTopBar || false,
      callback: action.callback || (() => { console.log(`${action.text} clicked`) })
      })),
    }
    });
  }

  addExpense(): void {
    this._expenseService.addExpense();
  }

  addPayment(): void {
    this._paymentService.addPayment();
  }

  addVehicule(): void {
    this._vehiculeService.addVehicule();
  }

  addResource(): void {
    this._resourceService.addResource();
  }
  save(): void {
    this._pageActionStateService.setSaveClicked(true);
  }

  saveaddnew(): void {
    this._pageActionStateService.setSaveAndNewClicked(true);
  }

  add(){
    this._pageActionStateService.setAddClicked(true);
  }

  ngOnDestroy(): void {
    // Clean up subscriptions to prevent memory leaks
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
  }

  isBulkModeActiveOnCalendarRoute(): boolean {
    return this.router.url.startsWith('/calendar') && this._bulkSchedulingStateService.isActive();
  }

  isMultiSelectActiveOnCalendarRoute(): boolean {
    return this.router.url.startsWith('/calendar') && this._calendarSelectionState.isMultiSelectActive();
  }

}
